<div class="student-play-container p-4 position-relative">
    <!-- progress bar & close button -->
    <div *ngIf="unAnsweredListDetails" class="d-flex align-items-end">
        <div class="w-100">
            <p class="text-12-400-133 text-c2">{{'Questions completed' | translate}}</p>
            <div class="progress">
                <div class="progress-bar bg-primary" role="progressbar"
                    [style.width.%]="unAnsweredListDetails?.completed_question_percentage || 0" aria-valuenow="12"
                    aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </div>
        <div class="ps-5">
            <img (click)="cancelQuiz()" width="16" src="assets/icons/close.svg" alt="close_icon">
        </div>
    </div>
    <!-- category & Time -->
    <div *ngIf="questionDetails" class="my-5 w-100 d-flex justify-content-between align-items-center">
        <button class="ctgry text-14-500-121 text-c6">
            <img class="me-2" width="20" [src]="questionDetails.category.image" alt="">
            {{questionDetails.category.name | translate}}
        </button>
        <span class="text-20-500-120 text-c2 d-flex align-items-center gap-3">
            <img width="24" src="assets/icons/stopwatch.svg" alt="">
            {{timeRemaining}}
        </span>
    </div>

    <div *ngIf="questionDetails?.image" (click)="showImage()"
        style="cursor:pointer;min-width: 100%;height: 200px;position: relative; overflow: hidden;border-radius:0.5rem">
        <img style="width: 100%;object-fit: cover;height: 100%;" [src]="questionDetails?.image" alt="Image description">
        <span class="view-icon text-16-400-175">{{'View' | translate}}</span>
    </div>
    <!-- question details -->
    <div *ngIf="questionDetails" class="pb-5">
        <p class="text-14-500-142 text-c5">QNID {{questionDetails.question_number}}</p>
        <p class="text-16-500-150 text-c6 mb-5">{{getTranslation(questionDetails,'title')}}</p>
        <div class="answer-options mb-4 text-12-600-121 text-c2 c-pointer"
            *ngFor="let option of questionDetails.options" (click)="selectOption(option.id)" [ngClass]="{
            'no-events': hasAnswered,
            'selectedOption': selectedOption === option.id && showTempStyle,
            'correct-option': option.id === correctOption && hasAnswered && !showTempStyle,
            'wrong-option': option.id === selectedOption && option.id !== correctOption && hasAnswered && !showTempStyle
        }">
            <ng-container *ngIf="hasAnswered && !showTempStyle">
                <img *ngIf="option.id === correctOption" src="assets/icons/correct.svg" alt="">
                <img *ngIf="option.id !== correctOption && selectedOption === option.id" src="assets/icons/wrong.svg"
                    alt="">
            </ng-container>
            {{getTranslation(option,'description')}}
        </div>
    </div>
    <!-- gif animation after option selected -->
    <!-- correct answer anim -->
    <ng-container *ngIf="questionDetails">
        <div *ngIf="showAnim && isCorrect" class="mt-10 mb-5 d-flex justify-content-center align-items-center">
            <img width="60" src="assets/icons/congratulations.gif" alt="">
            <div>
                <div class="text-24-500-116 text-c4">{{'Great!' | translate}}</div>
                <div class="text-12-500-166 text-c5">{{'Your answer is correct!' | translate}}</div>
            </div>
        </div>
        <!-- wrong answer anim -->
        <div *ngIf="showAnim && !isCorrect" class="mt-10 mb-5 d-flex justify-content-center align-items-center">
            <img width="70" src="assets/icons/wrong.gif" alt="">
            <div>
                <div class="text-13-500-130 text-c4">{{'Oops!' | translate}}</div>
                <div class="text-12-500-166 text-c5">{{'Your answer is wrong!' | translate}}</div>
            </div>
        </div>
    </ng-container>
</div>